// extracted by mini-css-extract-plugin
export var buy = "style-module--buy--14d6a";
export var buyBtn = "style-module--buy-btn--3372e";
export var card = "style-module--card--ee490";
export var cardItem = "style-module--card-item--d4a8e";
export var cardList = "style-module--card-list--4f98b";
export var cardMotivation = "style-module--card--motivation--bff10";
export var cardText = "style-module--card-text--a6d6b";
export var cardTextGift = "style-module--card-text--gift--c70c4";
export var cardTitle = "style-module--card-title--1737c";
export var cardTrial = "style-module--card--trial--2752d";
export var cardsWrap = "style-module--cards-wrap--a029f";
export var cost = "style-module--cost--dc192";
export var get = "style-module--get--26b0e";
export var getBtn = "style-module--get-btn--9158d";
export var getText = "style-module--get-text--9fb13";
export var getVid = "style-module--get-vid--70c48";
export var getVid__bg = "style-module--get-vid__bg--c2fc1";
export var getVid__title = "style-module--get-vid__title--96655";